import React from "react";

interface ReportActionsProps {
  onGenerate: () => void;
  onDownload: () => void;
  onRequest: () => void;
  onDelete: () => void;
  canDelete: boolean;
}

const ReportActions: React.FC<ReportActionsProps> = ({
  onGenerate,
  onDownload,
  onDelete,
  onRequest,
  canDelete,
}) => (
  <div className="flex flex-wrap gap-3">
    <button
      onClick={onGenerate}
      className="flex items-center gap-2 px-4 py-2 border border-green-600 text-green-600 hover:bg-green-50 font-semibold rounded-md transition"
    >
      📄 Generate
    </button>

    <button
      onClick={onDownload}
      className="flex items-center gap-2 px-4 py-2 border border-gray-700 text-gray-700 hover:bg-gray-100 font-semibold rounded-md transition"
    >
      ⬇ Download
    </button>
    <button
      onClick={onRequest}
      className="flex items-center gap-2 px-4 py-2 border border-gray-700 text-blue-700 hover:bg-gray-100 font-semibold rounded-md transition"
    >
      Request
    </button>

    {canDelete && (
      <button
        onClick={onDelete}
        className="flex items-center gap-2 px-4 py-2 border border-red-600 text-red-600 hover:bg-red-50 font-semibold rounded-md transition"
      >
        🗑️ Delete Selected
      </button>
    )}
  </div>
);

export default ReportActions;
